/**
 * Technomarine — "Te puede gustar" dentro del drawer del carrito.
 * Toma productos de una colección fija (data-collection-url), descarta los que ya
 * están en el carrito y permite agregarlos con el botón "+".
 * Se refresca cada vez que el drawer se abre. JS plano (sin módulos).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-cart-cross-sell]');
  var wrapper = document.querySelector('[data-cart-popup-wrapper]');
  if (!root || !wrapper) return;

  var list = root.querySelector('[data-cross-sell-list]');
  var prevBtn = root.querySelector('[data-cross-sell-prev]');
  var nextBtn = root.querySelector('[data-cross-sell-next]');
  var maxItems = parseInt(root.dataset.maxItems, 10) || 8;
  var refreshId = 0;
  var collectionPromise = null;
  var drag = null;

  /* ---------- utilidades ---------- */

  function formatMoney(value) {
    var cents = Math.round(parseFloat(value) * 100);
    if (window.theme && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function fetchCart() {
    return getJSON((root.dataset.cartUrl || '/cart') + '.js');
  }

  // La colección no cambia mientras se navega: se pide una sola vez.
  function fetchCollection() {
    if (!collectionPromise) {
      var url = root.dataset.collectionUrl + '/products.json?limit=' + (root.dataset.limit || 12);
      collectionPromise = getJSON(url)
        .then(function (data) { return (data && data.products) || []; })
        .catch(function () { collectionPromise = null; return []; });
    }
    return collectionPromise;
  }

  /* ---------- render ---------- */

  function priceEl(variant) {
    var wrap = document.createElement('span');
    wrap.className = 'cart-cross-sell__price';
    var onSale = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);

    if (onSale) {
      var compare = document.createElement('span');
      compare.className = 'cart-cross-sell__price-compare';
      compare.textContent = formatMoney(variant.compare_at_price);

      var current = document.createElement('span');
      current.className = 'cart-cross-sell__price-current cart-cross-sell__price-current--sale';
      current.textContent = formatMoney(variant.price);

      var pct = Math.round((1 - parseFloat(variant.price) / parseFloat(variant.compare_at_price)) * 100);
      var discount = document.createElement('span');
      discount.className = 'cart-cross-sell__price-discount';
      discount.textContent = '[-' + pct + '%]';

      wrap.appendChild(compare);
      wrap.appendChild(current);
      wrap.appendChild(discount);
    } else {
      var only = document.createElement('span');
      only.className = 'cart-cross-sell__price-current';
      only.textContent = formatMoney(variant.price);
      wrap.appendChild(only);
    }
    return wrap;
  }

  function render(products) {
    list.innerHTML = '';

    products.forEach(function (product) {
      var variants = product.variants || [];
      var variant = variants.filter(function (v) { return v.available; })[0];
      if (!variant) return;
      var needsOptions = variants.length > 1; // varias variantes: mandar a la ficha del producto
      var productUrl = '/products/' + product.handle;

      var li = document.createElement('li');
      li.className = 'cart-cross-sell__item';

      var media = document.createElement('a');
      media.className = 'cart-cross-sell__media';
      media.href = productUrl;
      media.draggable = false;
      if (product.images && product.images[0]) {
        var src = product.images[0].src;
        var img = document.createElement('img');
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
        img.alt = product.title || '';
        img.loading = 'lazy';
        img.draggable = false;
        media.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'cart-cross-sell__info';
      var title = document.createElement('a');
      title.className = 'cart-cross-sell__title';
      title.href = productUrl;
      title.textContent = product.title;
      title.draggable = false;
      info.appendChild(title);
      info.appendChild(priceEl(variant));

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'cart-cross-sell__add';
      add.textContent = '+';
      add.setAttribute('aria-label', (needsOptions ? 'Ver opciones de ' : 'Añadir ') + product.title);
      add.addEventListener('click', function () {
        if (needsOptions) { window.location.href = productUrl; return; }
        addToCart(variant.id, add);
      });

      li.appendChild(media);
      li.appendChild(info);
      li.appendChild(add);
      list.appendChild(li);
    });

    list.scrollLeft = 0;
    updateNav();
  }

  /* ---------- carga / refresco ---------- */

  function refresh() {
    var id = ++refreshId;

    Promise.all([fetchCart(), fetchCollection()]).then(function (res) {
      if (id !== refreshId) return;
      var cart = res[0];
      var products = res[1];

      if (!cart || !cart.items || !cart.items.length) { root.hidden = true; return; }

      var inCart = {};
      cart.items.forEach(function (item) { inCart[item.product_id] = true; });

      var suggestions = products
        .filter(function (p) {
          return !inCart[p.id] && (p.variants || []).some(function (v) { return v.available; });
        })
        .slice(0, maxItems);

      if (!suggestions.length) { root.hidden = true; return; }

      render(suggestions);
      root.hidden = false;
      updateNav();
    }).catch(function () { root.hidden = true; });
  }

  /* ---------- agregar al carrito ---------- */

  function addToCart(variantId, button) {
    if (button.disabled) return;
    button.disabled = true;

    fetch(root.dataset.addUrl || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'error'); return j; }); })
      .then(function () {
        button.classList.add('is-added');
        button.textContent = '✓';
        return fetchCart();
      })
      .then(function (cart) {
        if (cart) syncCartCount(cart.item_count);
        // Deja ver el ✓ un instante y luego quita el producto agregado de la lista.
        setTimeout(refresh, 700);
      })
      .catch(function (e) {
        console.error('[cart-cross-sell]', e);
        button.disabled = false;
      });
  }

  function syncCartCount(count) {
    var ctaCount = document.querySelector('[data-cart-popup-cart-quantity]');
    if (ctaCount) ctaCount.textContent = count;
    var bubble = document.querySelector('[data-cart-count-bubble]');
    var num = document.querySelector('[data-cart-count]');
    if (bubble) bubble.classList.remove('hide');
    if (num) num.textContent = count;
  }

  /* ---------- carrusel: flechas + arrastre ---------- */

  function updateNav() {
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth - 1;
    prevBtn.disabled = list.scrollLeft <= 0;
    nextBtn.disabled = list.scrollLeft >= max;
  }

  function scrollBy(dir) {
    var card = list.querySelector('.cart-cross-sell__item');
    var step = (card ? card.getBoundingClientRect().width : 144) + 12;
    list.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', function () { scrollBy(-1); });
  nextBtn.addEventListener('click', function () { scrollBy(1); });
  list.addEventListener('scroll', updateNav, { passive: true });

  list.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.target.closest('.cart-cross-sell__add')) return;
    drag = { x: e.clientX, left: list.scrollLeft, moved: false, id: e.pointerId };
  });
  list.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 3) {
      drag.moved = true;
      list.setPointerCapture(drag.id);
      list.classList.add('is-dragging');
    }
    if (drag.moved) list.scrollLeft = drag.left - dx;
  });
  function endDrag(e) {
    if (!drag) return;
    list.classList.remove('is-dragging');
    if (drag.moved) {
      // evita que el arrastre termine abriendo el producto
      list.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
      if (list.hasPointerCapture(e.pointerId)) list.releasePointerCapture(e.pointerId);
    }
    drag = null;
  }
  list.addEventListener('pointerup', endDrag);
  list.addEventListener('pointercancel', endDrag);

  /* ---------- se refresca cada vez que el drawer se abre ---------- */

  var wasHidden = wrapper.classList.contains('cart-popup-wrapper--hidden');
  new MutationObserver(function () {
    var isHidden = wrapper.classList.contains('cart-popup-wrapper--hidden');
    if (wasHidden && !isHidden) refresh();
    wasHidden = isHidden;
  }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
})();